<template>
  <vuestic-widget header-text="Picking">
    <div>
      <div class="form-group">
        <div class="input-group mr-1">
          <label for="bodeguero">Bodeguero</label>
          <select @change="$refs.folio.focus()" v-model="bodeguero" name="bodeguero" id="bodeguero">
            <option value="">Seleccione...</option>
            <option v-for="usuario in usuarios" :value="usuario">{{usuario.nombre}}</option>
          </select>
          <i class="bar"></i>
        </div>
        <div class="input-group">
          <label for="folio">Folio Voucher</label>
          <input @change="push(folio_voucher)" ref="folio" v-model="folio_voucher" type="text" id="folio"/>
          <i class="bar"></i>
        </div>
      </div>
      <hr>
      <table class="table table-striped table-bordered pointer table-hover">
        <thead class="thead-light">
        <tr>
          <th>FOLIO</th>
          <th>FECHA</th>
          <th>VENDEDOR</th>
          <th>ESTADO</th>
        </tr>
        </thead>
        <tbody>
        <tr :class="{'table-warning': item.estado === 'pendiente', 'table-success': item.estado === 'entregado'}"
            @click="push(item.voucher_folio)" v-for="item in vouchers">
          <td>{{ item.voucher_folio }}</td>
          <td>{{ item.created_at | date("DD/MM/YYYY") }}</td>
          <td>{{ item.vendedor.nombre }}</td>
          <td>{{ item.estado | upper }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </vuestic-widget>
</template>

<script>

  import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
  import InputComp from "../../Componentes_Globales/Input/inputComp";
  import makeQuery from "../../../api/helper";

  export default {
    name: "listarPicking",
    components: {InputComp, VuesticWidget},
    created() {
      this.$store.dispatch('loadUsuarios')
      this.getPicking()
    },
    computed: {
      usuarios() {
        return this.$store.getters.usuarios.filter(item => item.roles.some(s => s.value === "BODEGA"))
      },
      vouchers() {
        return this.pickings.reduce((accumulate, current) => {
          if (accumulate.find(acc => acc.voucher_folio === current.voucher_folio) === undefined)
            return [...accumulate, current]
          return accumulate
        }, [])
      },

    },
    methods: {
      push(folio) {
        if (this.bodeguero === "") return this.$swal('Alerta!!', 'Debe Seleccionar un Bodeguero...', 'warning')
        this.$router.push({
          path: "ver-picking",
          query: {folio, bodeguero: this.bodeguero.nombre, bodeguero_id: this.bodeguero.id}
        })
      },
      getPicking() {
        const query = makeQuery({filtros: this.createQuery()})
        this.$axios.get("/sucursales/picking" + query + "&ordenar_por=createdAt&orden=desc")
          .then(resp => this.pickings = resp.data.items)
          .catch(e => console.error(e))
      },
      createQuery() {
        return [
          {field: "sucursal.id", operator: "=", value: window.localStorage.sucursal_id},
        ]
      }
    },
    data() {
      return {
        pickings: [],
        bodeguero: "",
        folio_voucher: ""
      }
    }
  }
</script>

<style scoped>

  .table-complete {
    background: #0fb300;
  }

  .table-pending {
    background: yellow;
  }

</style>
